var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('td',{staticClass:"table-empty",class:{ 'text-center': _vm.center },attrs:{"colspan":_vm.colspan}},[_vm._v("Leitaðu til þess að fá niðurstöður")])])
}
var staticRenderFns = []

export { render, staticRenderFns }